import React, { Fragment } from 'react';
import { Col, FormGroup, Input, Label } from 'reactstrap';

const ChannelRadioGroup = ({ id, handleRadioChange, states, title, type, value }) => {
  // Safeguard the URL param in case the user modified the URL.  Default to 'live'
  const parseTypeParam = type === 'timed' ? type : 'live';

  // Use the title to create our label names
  const labelName = `postSale${title}`;
  const labelRadio = `${labelName}Radio`;
  const labelRadioAvailableLive = `${labelRadio}Live`;
  const labelRadioAvailableNonLive = `${labelRadio}NonLive`;
  const labelRadioUnavailable = `${labelRadio}Unavailable`;

  // Parse the states array to determine which radio options to show
  const unavailableOption = states.includes(0);
  const liveOption = states.includes(2);
  const viewOnlyOption = states.includes(1);

  // In the case of only the "Live Option" or only "View Only", we don't show radio buttons
  const disableOptionsLive = liveOption && !unavailableOption && !viewOnlyOption;
  const disableOptionsViewOnly = !liveOption && !unavailableOption && viewOnlyOption;

  const availableLiveText = `Available on site / ${parseTypeParam}`;
  const availableViewOnlyText = 'Available on site / View only';
  const unavailableText = 'Not available on site';

  return (
    <Col xs={6} className="mt-3">
      <Label for={labelName} className="mb-2">
        {title}
      </Label>

      {disableOptionsLive && <p>{availableLiveText}</p>}
      {disableOptionsViewOnly && <p>{availableViewOnlyText}</p>}

      {!disableOptionsLive && !disableOptionsViewOnly && (
        <Fragment>
          <FormGroup check className="mb-2">
            <Label for={labelRadioUnavailable} check>
              <Input
                id={labelRadioUnavailable}
                type="radio"
                name={labelRadio}
                checked={!value || value === 0}
                onChange={() => handleRadioChange(id, 0)}
              />
              {unavailableText}
            </Label>
          </FormGroup>

          {liveOption && (
            <FormGroup check className="mb-2">
              <Label for={labelRadioAvailableLive} check>
                <Input
                  id={labelRadioAvailableLive}
                  type="radio"
                  name={labelRadio}
                  checked={value === 2}
                  onChange={() => handleRadioChange(id, 2)}
                />
                {availableLiveText}
              </Label>
            </FormGroup>
          )}

          {viewOnlyOption && (
            <FormGroup check className="mb-2">
              <Label for={labelRadioAvailableNonLive} check>
                <Input
                  id={labelRadioAvailableNonLive}
                  type="radio"
                  name={labelRadio}
                  checked={value === 1}
                  onChange={() => handleRadioChange(id, 1)}
                />
                {availableViewOnlyText}
              </Label>
            </FormGroup>
          )}
        </Fragment>
      )}
    </Col>
  );
};

export default ChannelRadioGroup;
